export var getAriaLabel = function (i18nStrings, columnName) { return function (_a) {
    var sortingColumn = _a.sortingColumn, sortingDescending = _a.sortingDescending;
    if (sortingColumn !== columnName) {
        return i18nStrings.labelNotSorted(columnName);
    }
    var sortingDirection = sortingDescending ? 'Descending' : 'Ascending';
    return i18nStrings["labelSorted" + sortingDirection](columnName);
}; };
//# sourceMappingURL=aria-label.js.map